import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PipesModule } from '../../../pipes';

@Component({
  selector: 'lib-calendar-slot-button',
  templateUrl: './calendar-slot-button.component.html',
  styleUrls: ['./calendar-slot-button.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PipesModule,
    // material design
    MatButtonModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarSlotButtonComponent {
  @Input() displayTextAsDate: boolean;
  @Input() slot: Date;
  @Input() isSelected: boolean;
  @Input() disabled: boolean;
  @Input() textOnly: boolean;
  @Input() includeDiscount: boolean;

  @Output() clicked = new EventEmitter<Date>();

  public selectSlot(): void {
    if (this.textOnly || this.disabled || this.isSelected) {
      return;
    }

    this.clicked.emit(this.slot);
  }
}
